import { WorkingCalendarEntry } from "../_modelsTS/WorkingCalendarEntry";

export class WorkingCalendarEntriesMapper {
    static allServerToLocal(entries = []) {
        return entries.map(this.serverToLocal);
    }
    
    static serverToLocal(entry): WorkingCalendarEntry {
        return {
            uid: entry.uid,
            begin: new Date(entry.begin),
            end: new Date(entry.end),
            description: entry.description,
        };
    }
}